import type { CityConfig } from "../city-template/types";

export const carlsbadNmConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Carlsbad",
  state: "New Mexico",
  stateAbbr: "NM",
  slug: "carlsbad-nm",
  route: "/cities/carlsbad-nm",
  title: "Emergency Passport Carlsbad, NM — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Carlsbad, NM — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Carlsbad Caverns visitors, Permian Basin energy workers, and Eddy County families.",
  h1: "Emergency & Expedited Passport Services in Carlsbad, New Mexico",
  heroSubtitle: "Carlsbad Caverns National Park ranger heading to an international cave conservation conference? Permian Basin oil field engineer with an overseas equipment training? Eddy County family with a last-minute vacation to Mexico? We help Carlsbad residents get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Carlsbad%20New%20Mexico%20downtown%20along%20the%20Pecos%20River%20with%20the%20iconic%20Carlsbad%20Flume%20aqueduct%2C%20the%20towering%20entrance%20to%20Carlsbad%20Caverns%20National%20Park%20with%20dramatic%20limestone%20formations%2C%20the%20Living%20Desert%20Zoo%20and%20Gardens%20State%20Park%20showcasing%20Chihuahuan%20Desert%20landscape%2C%20oil%20pump%20jacks%20scattered%20across%20the%20Eddy%20County%20landscape%20at%20golden%20hour%2C%20warm%20desert%20tones%20and%20dramatic%20sky%2C%20professional%20travel%20photography&width=1800&height=700&seq=carlsbad-nm-hero-2026&orientation=landscape",
  heroImageAlt: "Carlsbad New Mexico with Pecos River flume and Carlsbad Caverns entrance",
  geoPosition: "32.4207;-104.2288",
  geoPlacename: "Carlsbad, New Mexico",
  lastModified: "2026-06-08",
  regionalAgency: {
    name: "El Paso Passport Agency",
    address: "700 E San Antonio Ave, Suite 200N, El Paso, TX 79901",
    distance: "Located in downtown El Paso, TX — approximately 160 miles southwest of Carlsbad. The nearest passport agency serving the region.",
  },
  nearbyCitiesZips: [
    { name: "Carlsbad", zips: "88220–88221" },
    { name: "Artesia", zips: "88210–88211" },
    { name: "Loving", zips: "88256" },
    { name: "Hope", zips: "88250" },
    { name: "Hobbs", zips: "88240–88242" },
    { name: "Roswell", zips: "88201–88203" },
    { name: "Whites City", zips: "88268" },
  ],
  benefits: [
    { icon: "ri-landscape-line", title: "Carlsbad Caverns National Park", desc: "Carlsbad Caverns National Park draws visitors from around the world. Park rangers, cave researchers, and interpretive staff regularly travel internationally for conservation conferences, geological symposiums, and sister-park exchanges." },
    { icon: "ri-oil-line", title: "Permian Basin Energy & Potash Mining", desc: "Carlsbad sits at the heart of the Permian Basin — the most productive oil field in the U.S. Mosaic's potash mining operations, oil service companies, and energy contractors create regular international travel for equipment training, global conferences, and overseas deployments." },
    { icon: "ri-plant-line", title: "Pecos River Agricultural Valley", desc: "The Pecos River Valley supports dairy, alfalfa, pecans, and cotton farming throughout Eddy County. Agricultural professionals travel internationally for equipment expos, trade shows, and farming technology conferences." },
    { icon: "ri-flight-takeoff-line", title: "Cavern City Air Terminal (CNM)", desc: "CNM offers connections to Albuquerque and Dallas for access to international gateways. While flight options are limited, the airport provides essential air service for Eddy County's international travelers." },
    { icon: "ri-road-map-line", title: "Cross-Border & Southwestern Access", desc: "Carlsbad is just 160 miles from El Paso and the U.S.-Mexico border. International trade, cross-border business, and family connections make passport services essential for many Eddy County residents." },
  ],
  internalLinks: [
    { name: "Fast passport services in Roswell, NM", route: "/cities/roswell-nm" },
    { name: "Expedited passport in Hobbs, NM", route: "/cities/hobbs" },
    { name: "Passport help in El Paso, TX", route: "/cities/el-paso" },
    { name: "New Mexico passport services overview", route: "/states/new-mexico" },
  ],
  fpcOfficeAddress: "700 E San Antonio Ave, Suite 200N, El Paso, TX 79901",
  fpcOfficeNote: "Fast Passport Center serves Carlsbad via secure registered courier with direct access to the El Paso Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the 160-mile drive. Carlsbad residents can ship from any UPS Store, FedEx Office, or post office location across Eddy County.",
  fpcOfficeDistance: "Serving Carlsbad, Artesia, Loving, Hope, Whites City, and all Eddy County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Carlsbad and all of Eddy County. From the downtown Canal Street district to Cavern City Air Terminal, from the Carlsbad Caverns visitor area to the Permian Basin oil fields — we serve the entire Carlsbad region. Our courier service eliminates the need to drive 2.5+ hours to El Paso.",
  nearbyCitiesIntro: "We serve Carlsbad and surrounding Eddy County communities including Artesia, Loving, Hope, and Whites City. We also serve the broader Permian Basin region and southeastern New Mexico energy corridor.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Carlsbad simple — with the reliability Permian Basin workers, Carlsbad Caverns professionals, and Eddy County families need. Because we are a registered U.S. Department of State courier, we pass those savings directly to you.",
  mistakesIntro: "Carlsbad travelers face unique passport challenges — from Permian Basin rotation schedules to Carlsbad Caverns seasonal staffing. Here are the most common mistakes we see from this area.",
  testimonialsIntro: "Southeastern New Mexico travelers — from cavern researchers to oil field engineers to Eddy County families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Carlsbad, NM? Here are the most common ones we hear from Eddy County travelers.",
  statePageRoute: "/states/new-mexico",
  statePageName: "New Mexico",
  servicesIntro: "Whether you need a renewal before an international cave conservation conference, an emergency passport for a Permian Basin deployment, or a first-time passport for an Eddy County family vacation — Fast Passport Center handles it with reserved courier submission availability.",
  dmvWebsite: "https://www.co.eddy.nm.us/",
  dmvLabel: "Eddy County — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No El Paso trip needed", "Ideal for energy workers and park staff", "Document review included", "Dedicated agent assigned", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned international travel", "Document review included"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review", "Not suitable if travel within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "El Paso agency is 160 miles from Carlsbad", "2.5+ hour drive — requires half-day minimum"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Permian Basin emergency deployment in 48 hours? Park service conference with immediate registration? Emergency processing as fast as 24 hours for Carlsbad travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Carlsbad residents renew fast — ideal for cavern researchers and energy professionals.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance step. We guide Carlsbad residents through every detail with clear instructions.",
      bullets: ["Step-by-step checklist", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require Form DS-64. We guide you through everything so your trip stays on track.",
      bullets: ["DS-64 form guidance", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minor child passport expedited service for Carlsbad and Eddy County families traveling abroad.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Carlsbad NM", description: "Urgent passport processing for Carlsbad New Mexico travelers." },
    { name: "Expedited Passport Renewal Carlsbad NM", description: "Fast passport renewal for Carlsbad and Eddy County residents." },
    { name: "First-Time Passport Carlsbad NM", description: "New passport application services for Carlsbad residents." },
    { name: "Child Passport Carlsbad NM", description: "Minor passport services for Carlsbad families." },
  ],
  testimonials: [
    {
      name: "Dr. Sarah V.",
      location: "Carlsbad",
      rating: 5,
      text: "Cave geologist attending an international speleology conference in Slovenia. My passport renewal needed to be expedited because the conference registration required valid passport numbers. Fast Passport Center had it back in 4 days. Essential for Carlsbad Caverns research professionals.",
      service: "Expedited Renewal",
    },
    {
      name: "Marcus J.",
      location: "Carlsbad",
      rating: 5,
      text: "Oil field completions engineer with a two-week notice for equipment training in Norway. Fast Passport Center renewed my passport in 5 days. Shipped from the UPS Store on Canal Street. For Permian Basin professionals, this service is indispensable.",
      service: "Passport Renewal — Rush",
    },
    {
      name: "The Hawley Family",
      location: "Artesia",
      rating: 5,
      text: "Three generations heading to a family wedding in Canada. Two adults needed renewals and one grandchild needed a first passport. Fast Passport Center processed all three in 7 days. The step-by-step guides made the child passport process straightforward.",
      service: "Family Passports",
    },
    {
      name: "Luis G.",
      location: "Loving",
      rating: 5,
      text: "Potash mine worker with family in Mexico. Needed my first passport for emergency family travel. Fast Passport Center guided me through the Carlsbad Post Office acceptance and had my passport in 6 days. For Eddy County residents, this is the only realistic fast option.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "car-1",
      name: "Carlsbad Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 W Stevens St",
      city: "Carlsbad",
      state: "NM",
      zip: "88220",
      phone: "(575) 885-3212",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Carlsbad",
      website: "https://tools.usps.com/find-location.htm?location=1376541",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility for Carlsbad and Eddy County. Photo services available on-site. Appointment recommended — especially during tourist season.",
      icon: "ri-mail-line",
    },
    {
      id: "car-2",
      name: "Eddy County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "325 S Main St",
      city: "Carlsbad",
      state: "NM",
      zip: "88220",
      phone: "(575) 885-3383",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Carlsbad — Eddy County Courthouse",
      website: "https://www.co.eddy.nm.us/",
      websiteLabel: "Eddy County Website",
      notes: "County clerk passport acceptance at the downtown courthouse. Appointment recommended. Convenient for county employees and downtown residents.",
      icon: "ri-government-line",
    },
    {
      id: "car-3",
      name: "Artesia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N 4th St",
      city: "Artesia",
      state: "NM",
      zip: "88210",
      phone: "(575) 746-3511",
      hours: "Mon–Fri 9:00 AM – 3:00 PM (appointment required)",
      distance: "Artesia — about 35 miles north of Carlsbad via US-285",
      website: "https://tools.usps.com/find-location.htm?location=1376534",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for northern Eddy County and Artesia residents. Limited hours — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "car-4",
      name: "Roswell Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "415 N Pennsylvania Ave",
      city: "Roswell",
      state: "NM",
      zip: "88201",
      phone: "(575) 622-4952",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Roswell — about 75 miles north of Carlsbad via US-285",
      website: "https://tools.usps.com/find-location.htm?location=1376547",
      websiteLabel: "USPS Location",
      notes: "Larger facility with more appointment availability. Full photo services. Good alternative when Carlsbad facilities are booked.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — El Paso Passport Agency, 160 miles from Carlsbad", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — 2.5+ hour drive to El Paso, TX", fpc: "Most Carlsbad travelers ship overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review to reduce delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission as registered courier" },
    { feature: "Practicality for Carlsbad", agency: "160 miles to El Paso — half-day trip minimum", fpc: "Entirely remote — ship from Carlsbad, receive at your door" },
    { feature: "Cost vs Resellers", agency: "Government fees plus travel costs and lost time", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Permian Basin Rotation Timing",
      description: "Energy workers on rotational schedules need to plan passport tasks carefully. Acceptance visits at the Carlsbad Post Office are only available during business hours Monday–Friday — plan your visit during your time off-rotation.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Carlsbad Caverns Peak Season Delays",
      description: "During the summer tourist season (May–September) and spring break, Carlsbad's population swells with visitors. Post office and county clerk appointments fill up faster. Schedule your acceptance visit 2-3 weeks before you plan to ship documents.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Carlsbad Air Terminal Flight Limitations",
      description: "CNM flights to Albuquerque and Dallas are limited. If bad weather or mechanical issues cause a cancellation, your international connection may be affected. Build extra time into your travel schedule — especially during summer monsoon season.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Cross-Border Documentation",
      description: "Carlsbad residents with family ties in Mexico may need additional documentation for passport applications — including foreign birth certificates with certified translations. We review all documentation requirements before submission.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed — Permian Basin deployment, park conference, or family travel." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "Personalized document checklist — energy worker, cavern researcher, or Eddy County family tailored." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Ship from the Carlsbad Post Office on Stevens Street or any FedEx/UPS in Eddy County." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Documents submitted through reserved agency slots — no El Paso drive needed." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives", description: "Completed within your timeframe and shipped to your Carlsbad or Eddy County address." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Carlsbad?", a: "We offer Carlsbad-area clients expedited processing as fast as 24 hours. Standard expedited through our courier channel takes 5–10 business days. The nearest regional agency is El Paso (160 miles) — our remote service is the practical fast option." },
    { q: "Do I need to visit an office in Carlsbad?", a: "No office visit for most services. Complete forms online, visit a local acceptance facility (Carlsbad Post Office or Eddy County Clerk) if you are a first-time applicant, then ship documents overnight. Adult renewals typically skip the acceptance step." },
    { q: "Where can I get passport acceptance in Carlsbad?", a: "Carlsbad Main Post Office on Stevens Street and the Eddy County Clerk at the courthouse on Main Street. Alternatives in Artesia (35 miles north) and Roswell (75 miles north). All require appointments." },
    { q: "Can I get a passport for cross-border travel to Mexico?", a: "Yes. Passport cards are available for land and sea crossings to Mexico and are popular for Eddy County residents with family and business ties across the border. We process both passport books and cards with the same expedited timelines." },
    { q: "What airport do Carlsbad travelers use?", a: "Cavern City Air Terminal (CNM) has Boutique Air flights to Albuquerque and Dallas. For more options, El Paso International (ELP, 160 miles) and Midland International (MAF, 150 miles) offer more connections to international gateways." },
    { q: "How does tourist season affect passport services?", a: "Carlsbad Caverns draws over 400,000 visitors annually. During peak season (May–September), acceptance facilities experience higher demand. We recommend scheduling your post office appointment early and using our remote courier service rather than driving to El Paso." },
    { q: "How do I get a passport photo in Carlsbad?", a: "Carlsbad Main Post Office offers on-site photos. UPS Store on Canal Street, Walgreens, and CVS also provide passport photos. Must be 2x2 inches, white background, no glasses, neutral expression." },
  ],
  photoLocations: [
    { name: "Carlsbad Main Post Office Photos", address: "210 W Stevens St, Carlsbad, NM 88220", hours: "Mon–Fri 9 AM – 4 PM", website: "https://tools.usps.com/find-location.htm" },
    { name: "UPS Store — Carlsbad", address: "2103 W Pierce St, Carlsbad, NM 88220", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM", website: "https://locations.theupsstore.com/nm/carlsbad" },
    { name: "Walgreens — Carlsbad", address: "102 N Canal St, Carlsbad, NM 88220", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/storelocator" },
  ],
  dmvLocations: [
    {
      name: "New Mexico MVD — Carlsbad",
      address: "901 W Pierce St, Carlsbad, NM 88220",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Full-service MVD. Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CNM",
      name: "Cavern City Air Terminal",
      distance: "About 7 miles southwest of downtown Carlsbad",
      address: "1501 Airport Dr, Carlsbad, NM 88220",
      note: "Boutique Air service with flights to Albuquerque (ABQ) and Dallas (DFW). Both connect to international gateways. Limited daily departures.",
      flightUrl: "https://www.cityofcarlsbadnm.com/",
      flightLabel: "CNM Airport Info",
      featured: true,
    },
    {
      code: "ELP",
      name: "El Paso International Airport",
      distance: "About 160 miles southwest (2.5 hours via US-62/US-180)",
      address: "6701 Convair Rd, El Paso, TX 79925",
      note: "Larger Texas airport with extensive domestic and international connections. Good option for Carlsbad travelers heading to Mexico or needing more flight choices.",
      flightUrl: "https://www.elpasointernationalairport.com/",
      flightLabel: "ELP Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified New Mexico birth certificates from the NM Department of Health.", url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Eddy County Clerk.", url: "https://www.co.eddy.nm.us/" },
  ],
};